import { createAction } from '@reduxjs/toolkit';

const fetchAvailabilityStarted = createAction(
  'availabiltiy/fetchAvailabilityStarted'
);
const fetchAvailabilitySucceeded = createAction(
  'availabiltiy/fetchAvailabilitySucceeded'
);
const fetchAvailabilityFailure = createAction(
  'availabiltiy/fetchAvailabilityFailure'
);

const setAvailability = createAction('resources/setAvailability');

const fetchBookabilityStarted = createAction(
  'availabiltiy/fetchBookabilityStarted'
);
const fetchBookabilitySucceeded = createAction(
  'availabiltiy/fetchBookabilitySucceeded'
);
const fetchBookabilityFailure = createAction(
  'availabiltiy/fetchBookabilityFailure'
);

const setBookability = createAction('resources/setBookability');

const PRICING_SECTION = {
  calendar: 'calendar',
  passenger: 'passenger',
};

export {
  fetchAvailabilityStarted,
  fetchAvailabilitySucceeded,
  fetchAvailabilityFailure,
  setAvailability,
  fetchBookabilityStarted,
  fetchBookabilitySucceeded,
  fetchBookabilityFailure,
  setBookability,
  PRICING_SECTION,
};
